var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7246 39.4904C37.585 38.2536 38.4176 37.0415 39.2779 35.8047C39.9718 37.0415 40.6379 38.2536 41.3317 39.4904C39.8052 39.4904 38.2788 39.4904 36.7246 39.4904Z",
    fill: "#9E04D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7076 39.1799C12.0703 38.4348 11.3837 36.5969 12.1759 35.057L23.1089 13.5979C23.9011 12.058 25.8553 11.4122 27.4926 12.1573C29.1299 12.9024 29.8166 14.7404 29.0243 16.2803L18.0914 37.7642C17.2991 39.2792 15.3449 39.925 13.7076 39.1799Z",
    fill: "url(#paint0_linear_2703_9944)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7864 39.1966C21.2726 38.4928 20.6201 36.7333 21.377 35.2754L28.163 21.8027C28.8938 20.3448 30.7208 19.7164 32.2346 20.4453C33.7484 21.1491 34.4009 22.9086 33.644 24.3665L26.858 37.8393C26.1272 39.2972 24.3002 39.9004 22.7864 39.1966Z",
    fill: "url(#paint1_linear_2703_9944)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0634 39.2185C29.5883 38.5542 28.9298 36.9059 29.641 35.5037L31.959 30.9524C32.6702 29.5748 34.435 28.9597 35.9364 29.624C37.4115 30.2882 38.07 31.9365 37.3588 33.3388L35.0408 37.89C34.3296 39.2923 32.5385 39.8827 31.0634 39.2185Z",
    fill: "url(#paint2_linear_2703_9944)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2703_9944",
    x1: 13.2137,
    y1: 39.6358,
    x2: 26.1754,
    y2: 11.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13AAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DDA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2703_9944",
    x1: 22.9727,
    y1: 38.5125,
    x2: 31.5292,
    y2: 20.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    stopColor: "#F79239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4154,
    stopColor: "#F28849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EC7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#E26185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05B8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2703_9944",
    x1: 31.1602,
    y1: 38.8772,
    x2: 35.3531,
    y2: 29.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#ED1E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#DF198E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    stopColor: "#C911A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C811A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiProfile);
export default __webpack_public_path__ + "static/media/AI_PROFILE.d681640c5fefa6f8de82da3a1b6bed2e.svg";
export { ForwardRef as ReactComponent };